// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { BarcodePrintStatus } from './barcode-print-status';
import { InvoiceHeader } from './invoice-header';
import { ItemBin } from './item-bin';
import { ItemDetailAddon } from './item-detail-addon';
import { ItemDetailLog } from './item-detail-log';
import { ItemDetailStatus } from './item-detail-status';
import { ItemReplacement } from './item-replacement';
import { JoDetail } from './jo-detail';
import { PoDetail } from './po-detail';
import { PoTrx } from './po-trx';
import { Product } from './product';
import { ShipBin } from './ship-bin';
import { BarcodePrintStatusEnum } from './enums';
import { ItemDetailStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ItemDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get isAccountOwned() { return this.accountId != null; }

  get isPendingScan() {
    return this.itemDetailStatusId == ItemDetailStatusEnum.InProcessPendingAddon
    || this.itemDetailStatusId == ItemDetailStatusEnum.InProcessPendingShipPrep
  }

  get isInProcess() {
    return this.itemDetailStatusId > ItemDetailStatusEnum.InInventory
    && this.itemDetailStatusId < ItemDetailStatusEnum.Shipped
  }

  /** Damaged, missing and migrated-unknown items are not goods. They must never
   *  reach an invoice line - shipQty is a row count, so one of these bills the
   *  customer for something that cannot ship. */
  get isShippableGoods() {
    return this.itemDetailStatusId != ItemDetailStatusEnum.DamagedOrOther
    && this.itemDetailStatusId != ItemDetailStatusEnum.MissingFromInventory
    && this.itemDetailStatusId != ItemDetailStatusEnum.MigratedUnknown
  }



  // returns either the name of the current process for this itemDetail or 'Not Yet Started' or 'Completed'
  getCurrentProcess() {
    // const completedSet = new Set<number>();
    // const notYetSet = new Set<number>();
    // for (var itdm of this.itemDetailAddons) {
    //   const stationId = itdm.addon.addonStationId
    //   if (itdm.processStatusId == ProcessStatusCode.InProcess) {
    //     return { addonStationId: stationId, description: stationId }
    //   }
    //   if (itdm.processStatusId == ProcessStatusCode.Completed) {
    //     if (notYetSet.has(stationId)){
    //       return { addonStationId: stationId, description: stationId }
    //     }
    //     completedSet.add(stationId);
    //   }
    //   if (itdm.processStatusId == ProcessStatusCode.NotYetStarted) {
    //     if (completedSet.has(stationId)) {
    //       return { addonStationId: stationId, description: stationId }
    //     }
    //     notYetSet.add(stationId);
    //   }
    // }
    // if (completedSet.size > 0 && notYetSet.size > 0) {
    //   return { addonStationId: null, description: 'Partial' }
    // }
    // if (completedSet.size > 0) {
    //   return { addonStationId: null, description: 'Completed' }
    // }
    // if (notYetSet.size > 0) {
    //   return { addonStationId: null, description: 'Not Yet Started' }
    // }
    // return { addonStationId: null, description: 'No Mods Necessary' }
    return 'Not yet implemented'

  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** String(12) key */
  id!: string;
  /** Int32 FK account */
  accountId?: number;
  /** String(10) FK accountPurchaseInvoiceHeader */
  accountPurchaseInvoiceHeaderId?: string;
  /** Int32 FK accountPurchaseJoDetail */
  accountPurchaseJoDetailId?: number;
  /** Enum FK barcodePrintStatus */
  barcodePrintStatusId!: BarcodePrintStatusEnum;
  /** DateTimeOffset */
  crtnTs?: Date;
  /** String(10) FK invoiceHeader */
  invoiceHeaderId?: string;
  /** Int32 FK itemBin */
  itemBinId!: number;
  /** Enum FK itemDetailStatus */
  itemDetailStatusId!: ItemDetailStatusEnum;
  /** Int32 FK joDetail */
  joDetailId?: number;
  /** DateTimeOffset */
  lastScanTs?: Date;
  /** Int32 FK poDetail */
  poDetailId?: number;
  /** Int32 FK poTrx */
  poTrxId?: number;
  /** Int32 FK product */
  productId!: number;
  /** Binary */
  rowVersion!: any;
  /** Int32 FK shipBin */
  shipBinId?: number;
  /** FK accountId */
  account!: Account;
  /** FK accountPurchaseInvoiceHeaderId */
  accountPurchaseInvoiceHeader!: InvoiceHeader;
  /** FK accountPurchaseJoDetailId */
  accountPurchaseJoDetail!: JoDetail;
  /** FK barcodePrintStatusId */
  barcodePrintStatus!: BarcodePrintStatus;
  /** FK invoiceHeaderId */
  invoiceHeader!: InvoiceHeader;
  /** FK itemBinId */
  itemBin!: ItemBin;
  /** Inv FK itemDetailId */
  itemDetailAddons!: ItemDetailAddon[];
  /** Inv FK itemDetailId */
  itemDetailLogs!: ItemDetailLog[];
  /** FK itemDetailStatusId */
  itemDetailStatus!: ItemDetailStatus;
  /** Inv FK itemDetailId */
  itemReplacement!: ItemReplacement;
  /** FK joDetailId */
  joDetail!: JoDetail;
  /** FK poDetailId */
  poDetail!: PoDetail;
  /** FK poTrxId */
  poTrx!: PoTrx;
  /** FK productId */
  product!: Product;
  /** FK shipBinId */
  shipBin!: ShipBin;
}

